'use strict';

var GridControlTypeDropdownDirective = function GridControlTypeDropdownDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    controller: 'GridControlTypeDropdownController',
    template: require('../templates/grid-control-type-dropdown.html')
  };
};
GridControlTypeDropdownDirective.$inject = [];
module.exports = GridControlTypeDropdownDirective;